import React from 'react'

import { Avatar } from '@fourthwall/components'

import * as S from './styled'
import type { Props } from './types'

export const ContributionSideSummaryHeader = ({ name }: Props) => (
  <S.Header>
    <S.Name>{name}</S.Name>
    <S.AvatarContainer>
      <Avatar name={name} />
    </S.AvatarContainer>
  </S.Header>
)
